module.exports = __webpack_public_path__ + "img/mypost-hover.8672ee96.svg";